import { RootState } from '../../store';

export const getTicketsSelector = (state: RootState) => state?.ticketReducer?.tickets || [];
